<template lang="pug">
  v-layout(row wrap)
    v-flex.header-acct(xs12)
      title-section(text="Billing & Limits")
        template(slot='icon')
          v-icon.mr-2(color="black") $vuetify.icons.credit-card-inverse
    v-flex.ml-1(xs12)
      p.current-plan Your current subscription is
        |&nbsp;
        span.current-plan-code CRM
      p.auto-renewal 1 month subscription term - Dec 03 2022 Auto-renewal is on
      v-layout(row wrap)
        v-flex(xs12)
          v-btn.ml-0.btn-cancel(
          ) Cancel Renewal
          v-btn(
            color="primary"
          ) Upgrade Account
    v-flex.mt-4(xs12)
      v-layout(row wrap)
        v-flex(xs11)
          v-layout.ml-1.card-content(row, wrap)
            limit-usage(:properties="billing.limits.email")
              template(slot='icon')
                v-btn.icon-container(
                  flat
                  icon
                )
                  v-icon.icon(small) email

            limit-usage(:properties="billing.limits.text")
              template(slot='icon')
                v-btn.icon-container(
                  flat
                  icon
                )
                  v-icon.icon(small) stay_current_portrait

            limit-usage(:properties="billing.limits.video")
              template(slot='icon')
                v-btn.vuetify-container(
                  flat
                  icon
                )
                  v-icon.vuetify-icon(small) $vuetify.icons.cellphone-play

    v-flex.mt-5.mb-3(xs12)
      title-section.mt-5(text="Active services", type="subtitle")
    v-flex(xs12)
      v-layout(row wrap)
        v-flex(xs12)
          v-card
            v-data-table(
              data-cy="services"
              disable-initial-sort
              hide-actions
              :headers="billing.activeServices.headers"
              :items="billing.activeServices.data"
              class="elevation-1"
            )
              template(slot="items" slot-scope="props")
                td {{ props.item.service }}
                td {{ props.item.status }}
                td {{ props.item.active_until }}
                td {{ props.item.next_billing_date }}

    v-flex(xs12)
      v-layout
        v-flex.mt-4(xs8)
          p.subtitle Recents Transactions
            span.date (Past 30 days)
        v-flex.mt-4(xs4)
          p.float-right.mt-3.primary--text Transaction History
    v-flex.mb-5(xs12)
      v-layout(row wrap)
        v-flex(xs12)
          v-card
            v-data-table(
              data-cy="services"
              disable-initial-sort
              hide-actions
              :headers="billing.recentTransactions.headers"
              :items="billing.recentTransactions.data"
              class="elevation-1"
            )
              template(slot="items" slot-scope="props")
                td {{ props.item.date }}
                td {{ props.item.amount }}
</template>
<script>
import TitleSection from './TitleSection';
import LimitUsage from './LimitUsage';
import { BILLING } from '../config';

export default {
  name: 'Billing',
  components: {
    TitleSection,
    LimitUsage,
  },
  data() {
    return {
      billing: BILLING,
    }
  },
}
</script>
<style lang="scss" scoped>
.current-plan {
  font-size: 20px;
  font-style: normal;
}

.current-plan-code {
  color: var(--v-primary-base);
}

.auto-renewal {
  font-weight: 600;
  margin-top: -10px;
}

.btn-cancel {
  background-color: #c16969 !important;
  color: white;
}

.icon-container .icon {
  text-align: center;
  border-radius: 20px;
  background-color: #9c9c9c;
  color: white;
  height: 35px;
  width: 35px;
  cursor: auto;
}


.vuetify-container {
  background-color: #9c9c9c;
  height: 35px;
  width: 35px;
  cursor: auto;
}

.vuetify-icon {
  color: white !important;
  height: 22px;
}

.subtitle {
  font-size: 20px;
  font-weight: 600;

  .date {
    font-size: 14px;
    margin-left: 15px;
    font-weight: lighter;
  }
}
</style>
